export default __webpack_public_path__ + "static/media/img12.92a41281.png";